(function () {
  const PREVIEW_LIMIT = 5;
  const CLIENT_CACHE_TTL_MS = 2 * 60 * 60 * 1000; // 2 hours

  const root = document.getElementById('product-supporters');
  if (!root) return;

  const productId = root.dataset.productId;
  const apiUrl = root.dataset.apiUrl;
  const loadingEl = document.getElementById('product-supporters-loading');
  const listEl = document.getElementById('product-supporters-list');
  const emptyEl = document.getElementById('product-supporters-empty');
  const viewAllBtn = document.getElementById('product-supporters-view-all');
  const modal = document.getElementById('product-supporters-modal');
  const modalBody = document.getElementById('product-supporters-modal-body');
  const modalClose = document.getElementById('product-supporters-modal-close');

  let badges = [];

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatTimeAgo(iso) {
    if (!iso) return '';
    const then = Date.parse(iso);
    if (Number.isNaN(then)) return '';
    const seconds = Math.round((Date.now() - then) / 1000);
    if (seconds < 45) return 'just now';
    const minutes = Math.round(seconds / 60);
    if (minutes < 60) return minutes === 1 ? '1 minute ago' : minutes + ' minutes ago';
    const hours = Math.round(minutes / 60);
    if (hours < 24) return hours === 1 ? '1 hour ago' : hours + ' hours ago';
    const days = Math.round(hours / 24);
    if (days < 30) return days === 1 ? '1 day ago' : days + ' days ago';
    const months = Math.round(days / 30);
    if (months < 12) return months === 1 ? '1 month ago' : months + ' months ago';
    const years = Math.round(days / 365);
    return years === 1 ? '1 year ago' : years + ' years ago';
  }

  function rowHtml(badge) {
    const name = escapeHtml(badge.customerName || 'Supporter');
    const href = escapeHtml(badge.url || '/pages/badges/' + badge.badgeId);
    const src = escapeHtml(badge.imageUrl);
    const ago = formatTimeAgo(badge.unlockedAt);
    const supportedAt = ago
      ? '<p class="text-xs text-gray-500 m-0">Supported At: ' + escapeHtml(ago) + '</p>'
      : '';

    return (
      '<li class="flex items-center gap-3">' +
      '<a href="' +
      href +
      '" class="shrink-0 block w-12 h-12 overflow-hidden rounded-sm border border-gray-200">' +
      '<img src="' +
      src +
      '" alt="' +
      name +
      ' badge" class="w-full h-full object-cover" width="48" height="48" loading="lazy" />' +
      '</a>' +
      '<div class="min-w-0 flex flex-col gap-0.5">' +
      '<p class="text-sm font-bold text-gray-900 m-0 truncate">' +
      name +
      '</p>' +
      supportedAt +
      '</div>' +
      '</li>'
    );
  }

  function hideSection() {
    root.classList.add('hidden');
    root.hidden = true;
    if (loadingEl) loadingEl.hidden = true;
    if (listEl) listEl.hidden = true;
    if (emptyEl) emptyEl.hidden = true;
    if (viewAllBtn) viewAllBtn.classList.add('hidden');
    closeModal();
  }

  /** Product loaded fine but nobody has supported it yet. */
  function showEmptyState() {
    root.classList.remove('hidden');
    root.hidden = false;
    if (loadingEl) loadingEl.hidden = true;
    if (listEl) listEl.hidden = true;
    if (viewAllBtn) viewAllBtn.classList.add('hidden');
    if (emptyEl) emptyEl.hidden = false;
  }

  function openModal() {
    if (!modal || !modalBody) return;
    modalBody.innerHTML =
      '<ul class="flex flex-col gap-3 list-none m-0 p-0">' + badges.map(rowHtml).join('') + '</ul>';
    modal.hidden = false;
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  function render(payload) {
    badges = (payload.badges || []).filter(function (b) {
      return b && b.badgeId && b.imageUrl;
    });

    if (!badges.length) {
      showEmptyState();
      return;
    }

    root.classList.remove('hidden');
    root.hidden = false;
    if (loadingEl) loadingEl.hidden = true;
    if (emptyEl) emptyEl.hidden = true;

    const preview = badges.slice(0, PREVIEW_LIMIT);
    listEl.innerHTML = preview.map(rowHtml).join('');
    listEl.hidden = false;

    if (badges.length > PREVIEW_LIMIT) {
      viewAllBtn.classList.remove('hidden');
    } else {
      viewAllBtn.classList.add('hidden');
    }
  }

  async function load() {
    root.classList.remove('hidden');
    root.hidden = false;
    if (loadingEl) loadingEl.hidden = false;
    if (listEl) listEl.hidden = true;
    if (emptyEl) emptyEl.hidden = true;

    const apiCache = window.RandamuApiCache;
    if (!apiCache || typeof apiCache.getOrFetch !== 'function') {
      hideSection();
      return;
    }

    try {
      const data = await apiCache.getOrFetch(
        apiUrl,
        async function () {
          const response = await fetch(apiUrl, {
            headers: {
              Accept: 'application/json',
            },
          });
          if (!response.ok) throw new Error('Bad response');
          const json = await response.json();
          if (!json || !Array.isArray(json.badges)) throw new Error('Invalid payload');
          return json;
        },
        { ttlMs: CLIENT_CACHE_TTL_MS }
      );
      render(data);
    } catch (e) {
      hideSection();
    }
  }

  if (viewAllBtn) {
    viewAllBtn.addEventListener('click', function (event) {
      event.preventDefault();
      openModal();
    });
  }
  if (modalClose) {
    modalClose.addEventListener('click', function (event) {
      event.preventDefault();
      closeModal();
    });
  }
  if (modal) {
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
  }
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });

  load();
})();
